import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Providers } from '@crt/platform-types/dist/enum';

import { ProvidersForSignIn } from '@app/auth/auth.model';
import { UserState } from '@app/auth/user.state';
import { EnvironmentService } from '@app/shared/environment.service';
import { isValueOfEnum } from '@app/shared/object.service';

const QUERY_PARAM_REDIRECT = 'redirect';
const QUERY_PARAM_EMAIL = 'email';

export const signinGuard: CanActivateFn = (route) => {
  const environmentService = inject(EnvironmentService);
  const router = inject(Router);
  const userState = inject(UserState);

  const url = new URL(`${environmentService.crtAPI}${environmentService.currentLocation}`);
  const user = userState.user();
  const provider = route.params.provider;
  const email = url.searchParams.get(QUERY_PARAM_EMAIL);
  const redirect = url.searchParams.get(QUERY_PARAM_REDIRECT);

  if (!isValueOfEnum(provider, { ...Providers, ...ProvidersForSignIn })) {
    return router.parseUrl(userState.consumeReturnTo());
  }

  if (redirect) {
    const redirectUrl = new URL(redirect, `https://${environmentService.hostname}`);
    const returnTo = `${redirectUrl.pathname}${redirectUrl.search}`;

    if (user && (!email || email === user.email)) {
      return router.parseUrl(returnTo);
    }

    userState.updateReturnTo$.next(returnTo);
    url.searchParams.delete(QUERY_PARAM_REDIRECT);
  }

  // Skip authentication redirect on feature branch environments to allow unauthenticated testing
  if (!user && !environmentService.hostname.includes('feature')) {
    window.location.href = `${url}`;
    return false;
  }

  return router.parseUrl(userState.consumeReturnTo());
};
